module.exports = __webpack_public_path__ + "img/code.4be888cc.jpg";